module.exports = __webpack_public_path__ + "img/food.22506a.svg";